<div class="d-flex justify-content-between">
    <button
        id="step-cancel"
        type="button"
        mat-stroked-button
        color="primary"
        class="flex-fill border-0 rounded-0 text-uppercase btn__sprintpay btn__sprintpay--greenBorder me-4"
        mat-button
        matStepperPrevious
        (click)="customPreviousHandler ? previousHandler() : null"
    >
        {{ previousText }}
    </button>
    @if (customNextHandler) {
        <button
            id="step-next"
            type="button"
            [disabled]="disabled"
            color="primary"
            class="flex-fill border-0 rounded-0 text-uppercase btn__sprintpay btn__sprintpay--green"
            mat-button
            (click)="nextHandler()"
        >
            {{ nextText }}
        </button>
    } @else {
        <button
            id="step-next"
            type="button"
            [disabled]="disabled"
            color="primary"
            class="flex-fill border-0 rounded-0 text-uppercase btn__sprintpay btn__sprintpay--green"
            mat-button
            matStepperNext
        >
            {{ nextText }}
        </button>
    }
</div>
